document.addEventListener('DOMContentLoaded', () => {
    const hasChildElements = document.querySelectorAll('.has_child');
    const burger = document.querySelector('.burger');
    const navWrapper = document.querySelector('.nav_wrapper');
    const closeBtn = document.querySelector('.close');
    
    hasChildElements.forEach((element) => {
        const subMenuActivate = element.querySelector('.toggle_btn');
        const subMenu = element.querySelector('.nav_sublist');
        
        subMenuActivate.addEventListener('click', () => {
            subMenu.classList.toggle('active');
            subMenuActivate.classList.toggle('active');
        });
    });
    
    burger.addEventListener('click', () => {
        burger.classList.toggle('active');
        navWrapper.classList.toggle('active');
    });
    
    closeBtn.addEventListener('click', () => {
        burger.classList.remove('active');
        navWrapper.classList.remove('active');
    });
});